import React from "react";
import "./Footer.css";
import {
  FaMapMarkerAlt,
  FaPhone,
  FaEnvelope,
  FaLinkedin,
  FaTwitter,
  FaInstagram,
  FaFacebook,
  FaGlobe,
} from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-grid">
          {/* Column 1: About Avvoka */}
          <div className="footer-section-avvoka">
            <h3 className="footer-header">Avvoka Exports</h3>
            <p className="footer-tagline">
              Exporting premium Kenyan fresh produce, tea, and coffee to global
              markets since 2020
            </p>
            <div className="footer-contact-info">
              <p>
                <FaMapMarkerAlt className="footer-icon" />
                Nairobi, Kenya
              </p>
              <p>
                <FaPhone className="footer-icon" />
                +254 727 834 517
              </p>
              <p>
                <FaEnvelope className="footer-icon" />
                Info@avvoka.co.ke
              </p>
              <p>
                <FaGlobe className="footer-icon" />
                www.avvoka.co.ke
              </p>
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div className="footer-section">
            <h3 className="footer-header">Quick Links</h3>
            <ul className="footer-links">
              <li>
                <a href="#home">Home</a>
              </li>
              <li>
                <a href="#about">About Us</a>
              </li>
              <li>
                <a href="#products">Products</a>
              </li>
              <li>
                <a href="#services">Export Services</a>
              </li>
              <li>
                <a href="#quality">Quality Assurance</a>
              </li>
              <li>
                <a href="#contact">Contact Us</a>
              </li>
            </ul>
          </div>

          {/* Column 3: Products */}
          <div className="footer-section">
            <h3 className="footer-header">Our Products</h3>
            <ul className="footer-links">
              <li>
                <a href="#vegetables">Fresh Vegetables</a>
              </li>
              <li>
                <a href="#fruits">Seasonal Fruits</a>
              </li>
              <li>
                <a href="#tea">Premium Tea</a>
              </li>
              <li>
                <a href="#coffee">Quality Coffee</a>
              </li>
              <li>
                <a href="#herbs">Herbs & Spices</a>
              </li>
              <li>
                <a href="#organic">Organic Products</a>
              </li>
            </ul>
          </div>

          {/* Column 4: Social & Newsletter */}
          <div className="footer-section">
            <h3 className="footer-header">Connect With Us</h3>
            <div className="footer-social-icons">
              <a href="#" aria-label="Facebook">
                <FaFacebook />
              </a>
              <a href="#" aria-label="Twitter">
                <FaTwitter />
              </a>
              <a href="#" aria-label="Instagram">
                <FaInstagram />
              </a>
              <a href="#" aria-label="LinkedIn">
                <FaLinkedin />
              </a>
            </div>

            <div className="footer-newsletter">
              <p className="newsletter-text">Stay updated with our exports</p>
              <form className="newsletter-form">
                <input
                  type="email"
                  placeholder="Your email address"
                  className="newsletter-input"
                  required
                />
                <button type="submit" className="newsletter-button">
                  Subscribe
                </button>
              </form>
              <p className="newsletter-disclaimer">
                We respect your privacy. Unsubscribe at any time.
              </p>
            </div>
          </div>
        </div>

        <div className="footer-divider"></div>

        <div className="footer-bottom">
          <div className="footer-copyright">
            <p>
              &copy; {new Date().getFullYear()} Avvoka Exports. All rights
              reserved.
            </p>
          </div>
          <div className="footer-legal">
            <a href="#privacypolicy">Privacy Policy</a>
            <a href="#termsofservice">Terms of Service</a>
            <a href="#sitemap">Sitemap</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
